<template>
    <loader v-if="loading"></loader>

    <div v-if="!loading"
         class="container -companies-detail">
        <edit-contact-modal :save-contact="saveContact"></edit-contact-modal>
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li><a v-link="{name: 'companies'}">Companies</a></li>
            <li>{{ company.name }}</li>
        </ol>

        <div class="header f -wrap -gutter-small">
            <div class="title expand">
                <h1>
                    <editable-text
                        :value.sync="company.name"
                        placeholder="Inconnue"
                    ></editable-text>
                </h1>
            </div>
            <div class="btn-group"
                 v-show="diff">
                <button class="btn btn-success btn-sm"
                        @click="save(company)"
                        :disabled="!valid">
                    <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button class="btn btn-danger btn-sm"
                        @click="cancel">
                    <i class="glyphicon glyphicon-remove"></i>
                </button>
            </div>
        </div>

        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation"
                :class="{active: tab === 'contacts'}">
                <a @click.prevent="switchTab('contacts')"
                   href="#"
                   role="tab">
                    Contacts
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'products', disabled: !company.id}">
                <a @click.prevent="switchTab('products')"
                   href="#"
                   role="tab">
                    Produits
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'documents', disabled: !company.id}">
                <a @click.prevent="switchTab('documents')"
                   href="#"
                   role="tab">
                    Documents
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'contracts', disabled: !company.id}">
                <a @click.prevent="switchTab('contracts')"
                   href="#"
                   role="tab">
                    Contrats
                </a>
            </li>
            <li role="presentation"
                :class="{active: tab === 'protocols', disabled: !company.id}">
                <a @click.prevent="switchTab('protocols')"
                   href="#"
                   role="tab">
                    Protocoles
                </a>
            </li>
        </ul>

        <div class="company-content">
            <div v-if="tab === 'contacts'">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 ">
                            <div class="item-edit -code">
                                <div class="name-field">Code</div>
                                <editable-text
                                    :value.sync="company.code"
                                    placeholder="Inconnue"
                                ></editable-text>
                            </div>
                        </div>
                        <div class="col-sm-9 col-md-9 col-lg-9 ">
                            <div class="item-edit -address">
                                <div class="address-field">Addresse</div>
                                <editable-text
                                    :is-address="true"
                                    :value.sync="company.address"
                                    placeholder="Inconnue"
                                ></editable-text>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 ">
                            <div class="item-edit">
                                <div class="name-field">Date de partenariat</div>
                                <editable-date
                                    :value.sync="company.partnership_date"
                                    placeholder="Inconnue"
                                    :enable-reset="true"></editable-date>
                            </div>
                        </div>
                        <div class="col-sm-9 col-md-9 col-lg-9 ">
                            <div class="item-edit">
                                <div class="name-field">Date de résiliation</div>
                                <editable-date :value.sync="company.resiliation_date"
                                               placeholder="Inconnue"
                                               :enable-reset="true"></editable-date>
                            </div>
                        </div>
                    </div>
                    <div class="row company-contacts">
                        <div class="col-md-12">
                            <h2>Contacts</h2>
                            <div class="row">
                                <contact-box v-for="contact in company.contacts"
                                             :is-company-contact="true"
                                             :contact="contact"
                                             :show-edit-modal="showEditModal"
                                             class-name="col-md-3"
                                ></contact-box>
                            </div>
                        </div>
                        <div class="add-contact">
                            <button class="btn btn-primary btn-sm"
                                    @click.prevent="addContact"
                                    :disabled="!company.id">
                                <i class="glyphicon glyphicon-plus"></i>
                                Ajouter un contact
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab === 'products'">
                <contract-types :company="company"></contract-types>
            </div>

            <div v-if="tab === 'documents'">
                <documents-tab :company="company"></documents-tab>
            </div>

            <div v-if="tab === 'contracts'">
                <contracts-tab :company="company"></contracts-tab>
            </div>

            <div v-if="tab === 'protocols'">
                <documents-tab :company="company" :is-protocol="true">
                </documents-tab>
            </div>
        </div>
    </div>
</template>

<style lang="less" type="text/less" scoped>
    .company-content {
        margin-top: 15px;
    }
    .item-edit {
        margin-top: 15px;
        .name-field {
            font-weight: bold;
        }
        .address-field {
            font-weight: bold;
            .input-address {
                min-width: 200px;
            }
        }
    }
</style>

<script>
    import router from '../router';
    import EditableText from '../components/editable/EditableText';
    import EditableDate from '../components/editable/EditableDate';
    import ContactBox from '../components/clients/ContactBox';
    import ContractTypes from '../components/companies/ContractTypes';
    import ContractsTab from '../components/companies/ContractsTab';
    import EditContactModal from '../components/contacts/EditContactModal';
    import DocumentsTab from '../components/clients/DocumentsTab';
    import Loader from '../components/Loader';
    import {
        update as updateCompany,
        create as createCompany,
        fetch as fetchCompany, emptyCompany
    } from '../api/companies';
    import {asyncAction} from '../utils';
    import {contactToData} from '../components/clients/utils';
    import {manager as msgManager} from '../messages';

    export default {
        components: {
            Loader,
            EditableText,
            ContactBox,
            ContractTypes,
            ContractsTab,
            EditContactModal,
            DocumentsTab,
            EditableDate
        },
        name: 'companies-detail',
        data() {
            return {
                tab: 'contacts',
                company: {},
                oldCompany: {},
                loading: false
            };
        },
        methods: {
            /**
             * Called when the user don't want to save the data, and rollback
             * the form
             **/
            cancel() {
                this.oldCompany.contacts = this.company.contacts;
                this.company = Object.assign({}, this.oldCompany);
            },
            /**
             * Call the api and save the contact
             **/
            save: asyncAction('loading', async function (company = this.company) {
                const method = this.company.id ? updateCompany : createCompany;
                const hasId = typeof this.company.id !== 'undefined';
                if (this.company.name.length === 0 && !this.company.id) {
                    msgManager.push(
                        'Attention',
                        'La compagnie ne sera pas sauvegardé tant que le nom n\'aura pas été modifié',
                        'warning'
                    );
                    return;
                }
                const companyToSave = Object.assign({}, company);
                companyToSave.address = JSON.stringify(companyToSave.address);
                this.company = await method(companyToSave);
                this.company.address = JSON.parse(this.company.address);
                this.oldCompany = Object.assign({}, this.company);
                if (!hasId) {
                    router.replace({name: 'companies-detail', params: {id: this.company.id}});
                }
                msgManager.push(
                    'Succès.',
                    'Les infos de la compagnie ont bien été mises à jour',
                    'success'
                );
            }),
            /**
             * Save contact and attach it to the company
             **/
            saveContact(editedContact) {
                const found = this.company.contacts.some((contact) => {
                    if (contact.id === editedContact.id) {
                        Object.assign(contact, editedContact);
                        return true;
                    }
                });

                if (!found) {
                    this.company.contacts.push(editedContact);
                }

                this.showModal = false;
                this.save(this.company);
            },
            /**
             * Open the addContact modal
             */
            addContact() {
                if (!this.company.id) {
                    msgManager.push(
                        'Attention',
                        'Vous devez d\'abord définir un nom pour cette compagnie',
                        'warning'
                    );
                    return;
                }
                this.$broadcast('show-edit-contact-modal', {});
            },
            /**
             * Open the edit contact modal
             */
            showEditModal(contact) {
                this.editContact = contactToData(contact);
                this.showModal = true;
                this.$broadcast('show-edit-contact-modal', contact);
            },
            /**
             * Go to the specified tab when user click on it
             */
            switchTab(tab) {
                if (!this.company.id) {
                    msgManager.push(
                        'Attention',
                        'Vous devez d\'abord définir un nom pour cette compagnie',
                        'warning'
                    );
                    return;
                }
                this.tab = tab;
            }
        },
        route: {
            data: async function (transition) {
                if (transition.to.params.id === 'new') {
                    this.company = emptyCompany();
                    this.oldCompany = Object.assign({}, this.company);
                    return;
                }
                this.loading = true;
                try {
                    const company = await fetchCompany(transition.to.params.id);
                    company.address = JSON.parse(company.address);
                    this.company = company;
                    this.oldCompany = Object.assign({}, this.company);
                    this.loading = false;
                } catch (e) {
                    router.replace({name: 'not-found'});
                }
            }
        },
        computed: {
            /**
             * Return true if all fields are valid, if so, the user can save
             * the form
             * @returns {boolean}
             */
            valid() {
                return this.company.name && this.company.name.length > 0;
            },
            /**
             * Return True if a field has been modified, if so, we show the
             * save button
             * @returns {boolean}
             */
            diff() {
                return (this.oldCompany.name !== this.company.name) ||
                    (this.oldCompany.code !== this.company.code) ||
                    (this.oldCompany.name !== this.company.name) ||
                    (this.oldCompany.address !== this.company.address) ||
                    (this.oldCompany.resiliation_date !==
                        this.company.resiliation_date) ||
                    (this.oldCompany.partnership_date !==
                        this.company.partnership_date);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// CompaniesDetail.vue?69c2269e